<template>
   <div ref="codeViewer" class="codeview-codepen">
      <div class="card">
         <div class="card-header">
            <button
               class="btn btn-sm btn-primary-grad text-uppercase"
               @click="btnAction"
               v-text="btnMessage"
            />

            <form
               class="codepen_form"
               action="https://codepen.io/pen/define"
               method="POST"
               target="_blank"
            >
               <input type="hidden" name="data" :value="codepenValue" />
               <button class="btn btn-sm btn-light text-uppercase">Edit In CodePen</button>
            </form>
         </div>
         <div class="card-body" :class="[{ active: state }]">
            <prism-code language="javascript" :code="getCode"></prism-code>
         </div>
      </div>
   </div>
</template>

<script>
import PrismCode from './Prism';

export default {
   components: {
      PrismCode,
   },
   props: {
      datasource: {
         type: Object,
         required: true,
      },
      codepenOptions: {
         type: Object,
         required: true,
      },
      chartType: {
         type: String,
         required: true,
      },
   },
   data: () => ({
      state: false,
      prismFlag: false,
      btnMessage: 'View Code',
   }),

   computed: {
      codepenValue() {
         // Pinned to the same FusionCharts version the site itself loads
         // (see client/index.template.html) - "latest" would silently drift
         // to whatever version CDN ships that day, which can behave
         // differently for event-heavy charts (annotations, hover handlers)
         // than what was actually built and tested against.
         const codepenJsExternal = [
            'https://ds.fusioncharts.com/2.0.6/css/ds.css',
            'https://cdn.fusioncharts.com/fusioncharts/3.19.0/fusioncharts.js',
            'https://cdn.fusioncharts.com/fusioncharts/3.19.0/themes/fusioncharts.theme.fusion.js',
         ].join(';');

         const codepenCssExternal = ['https://ds.fusioncharts.com/2.0.6/css/ds.css'].join(';');

         /**
          * more about config : https://blog.codepen.io/documentation/api/prefill/
          */
         const config = {
            title: this.datasource.chart.caption,
            description: 'Made with love from FusionCharts',
            editors: '101',
            layout: 'left',
            css_external: codepenCssExternal,
            js_external: codepenJsExternal,
            css: this.codepenOptions.cssCode,
            js: this.codepenOptions.jsCode,
            html: this.codepenOptions.htmlCode,
         };

         return JSON.stringify({
            ...config,
         });
      },

      getCode() {
         return `
         const dataSource = ${JSON.stringify(this.datasource, null, 2)};

         FusionCharts.ready(function() {
            const myChart = new FusionCharts({
               type: "${this.chartType}",
               renderAt: "chart-container",
               width: "100%",
               height: "500",
               dataFormat: "json",
               dataSource
            }).render();
         }`;
      },
   },

   async mounted() {
      this.$nextTick(() => {
         this.chartContainer = this.$refs.codeViewer && this.$refs.codeViewer.nextElementSibling;
      });
   },

   methods: {
      btnAction() {
         if (this.chartContainer) {
            this.state = !this.state;
            if (!this.prismFlag) {
               Prism.highlightAll();
               this.prismFlag = true;
            }
            if (this.state) {
               this.chartContainer.style.display = 'none';
               this.btnMessage = 'View Chart';
            } else {
               this.chartContainer.style.display = 'block';
               this.btnMessage = 'View Code';
            }
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.codeview-codepen {
   .card-header {
      padding: 10px 18px;
      border-bottom: 1px solid rgba(62, 57, 107, 0.13);
      width: 100%;
      background-color: white;
      text-align: right;
      .btn-sm {
         min-width: 120px;
         box-shadow: 0 4px 6px 0 rgba(50, 50, 93, 0.11);
         font-size: 13px;
         font-weight: 600;
         line-height: 16px;

         &.btn-sm.btn-light {
            color: #434456;
            padding: 0.8rem 1.2rem;
            border: 1px solid rgba(105, 87, 218, 0.06);
         }
      }
   }

   .card-body {
      display: none;
      height: 400px;
      overflow: scroll;
      max-width: 755px;
      &.active {
         display: block;
      }
   }

   @media only screen and (max-width: 425px) {
      .card-header {
         text-align: center;
      }
   }

   .codepen_form {
      display: inline;
      margin-left: 8px;
   }
}
</style>
